import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { useToastTracker } from "@/hooks/useToastTracker"
import { X } from "lucide-react"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()
  const toastCount = useToastTracker()

  return (
    <div className="relative">
      <Sonner
        theme={theme as ToasterProps["theme"]}
        className="toaster group"
        closeButton={true}
        position="top-right"
        
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            description: "group-[.toast]:text-muted-foreground",
            actionButton:
              "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton:
              "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
            closeButton:
              "group-[.toast]:!w-6 group-[.toast]:!h-6 sm:group-[.toast]:!w-5 sm:group-[.toast]:!h-5 group-[.toast]:!top-1 group-[.toast]:!right-1 group-[.toast]:!left-auto group-[.toast]:!border-border group-[.toast]:!bg-background group-[.toast]:!text-foreground",
          },
        }}
        {...props}
      />
      {toastCount >= 2 && (
        <button
          onClick={() => toast.dismiss()}
          className="fixed z-[999] flex items-center gap-1 rounded-full bg-background text-foreground border border-border px-3 py-1.5 text-xs font-medium shadow-lg hover:bg-destructive/15 hover:text-destructive hover:border-destructive/30 transition-all bottom-2 left-1/2 -translate-x-1/2 sm:bottom-auto sm:left-auto sm:translate-x-0 sm:top-2 sm:right-[21rem]"
          aria-label="Dismiss all notifications"
        >
          <X className="h-3.5 w-3.5" />
          Clear all ({toastCount})
        </button>
      )}
    </div>
  )
}

export { Toaster }
